<template>
  <div class="content">
    <el-form :model="queryParams"  ref="queryParams" :inline="true">
      <el-form-item prop="userId">
            <el-cascader
            placeholder="公司名"
            ref="myCascader"
            :options="agentList"
            :props="{ value : 'userId' ,checkStrictly: true,emitPath:false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
          >
            <template slot-scope="{ node, data }">
              <span>[{{ data.username }}]{{ data.label }}</span>
              <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
            </template>
          </el-cascader>
        </el-form-item>
      <el-form-item prop="bankAccount">
        <el-input  v-model="queryParams.bankAccount" placeholder="银行卡号" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item prop="bank">
        <el-input v-model="queryParams.bank" placeholder="开户行" @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item prop="auditStatus">
        <el-select v-model="queryParams.auditStatus" filterable placeholder="认证状态" @change="search">
          <el-option
            v-for="item in options"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button  icon="el-icon-refresh" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" min-width="260px" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="bankAccount" label="银行卡号" min-width="220px" :show-overflow-tooltip="true" align="center"></el-table-column>
      <el-table-column prop="bank" label="开户行" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="auditTime" label="审核时间" align="center" min-width="160px"></el-table-column>
      <el-table-column prop="auditStatus" label="审核状态" align="center">
        <template slot-scope="{row}">
          <el-tag v-if="row.auditStatus == '1'" type="primary">待审核</el-tag>
          <el-tag v-else-if="row.auditStatus =='2'" type="success">已通过</el-tag>
          <el-tag v-else-if="row.auditStatus =='3'" type="danger">拒绝</el-tag>
          <el-tag v-else type="primary">未审核</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="imgUrl" label="授权协议" align="center" :show-overflow-tooltip="true">
          <template slot-scope="{row}">
            <el-image v-if="!!row.imgUrl"
              style="width: 50px; height: 50px"
              :src="row.imgUrl"
              fit="fill"
              :preview-src-list="[row.imgUrl]">
            </el-image>
          </template>
      </el-table-column>
      <el-table-column label="操作" width="160" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button v-if="scope.row.auditStatus == '1' || scope.row.auditStatus == '0'" size="mini" type="primary" plain  icon="el-icon-s-check" @click="editRow(scope.row.id)" v-hasPermi="['authentication:bank:audit']" >审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
    <!-- 弹框审核操作 -->
    <el-dialog title="银行卡认证审核" :visible.sync="dialog" @close="dialogClose" :lock-scroll="false" width="700px" v-dialogDrag>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="审核状态" prop="status" label-width="160px">
          <el-select v-model="form.status" placeholder="请选择状态" style="width:350px">
            <el-option label="审核通过" value="2"></el-option>
            <el-option label="拒绝" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark" label-width="160px">
          <el-input type="textarea"  v-model="form.remark" style="width:350px"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center">
          <el-button type="primary" @click="cancelDialog">取消</el-button>
          <el-button type="success" @click="submitAudit">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { agentTreeList } from "@/api/api.js"; //代理商
import { listPage ,updateStatus} from "@/api/api.js"; //实名列表
export default {
  data() {
    return {
      //代理商层级
      agentList:[],
      queryParams:{
        userId:undefined,
        bankAccount:undefined,
        bank:undefined,
        auditStatus:undefined
      },
      page: 1,
      pageSize: 20,
      total: 0,
      options: [
        {
          key: "3",
          value: "拒绝"
        },
        {
          key: "1",
          value: "待审核"
        },
        {
          key: "2",
          value: "已通过 "
        },
      ],
      tableData: [],
      dialog:false,
      form:{
        id:undefined,
        status:undefined,
        remark:undefined,
      },
      rules:{
        status:[{ required: true, message: '请选择审核状态', trigger: 'blur' }]
      }
    };
  },
  computed: {},
  methods: {
    // 获取初始化代理商列表
    agentTreeListMethod(){
      agentTreeList().then(res => {
        this.agentList = res.data.data;
      });
    },
    dialogClose(){
      this.dialog = false;
    },
    cancelDialog(){
      this.dialog = false;  
    },
    submitAudit(){
      this.$refs["form"].validate(valid => {
        if (valid) {
          updateStatus(this.form).then(res=>{
              this.dialog = false;
              this.reset();
          });
        }
      });
    },
    // 获取列表
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      listPage(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    reset() {
      this.resetForm("queryParams");
      this.search();
    },
    // 详情
    editRow(id) {
      this.dialog = true;
      this.form.id = id;
    },
  },
  created() {
    this.initData();
    this.agentTreeListMethod();
  }
};
</script>


